
import { 
    IonCardHeader, IonCardTitle
  } from '@ionic/react';

function OtpHeader(){ 

    return (
        <>
             <IonCardHeader>
                <div><a href='/login' className='back-login'><img src='img/back.svg' /> </a></div>
             
                <img src='img/logo.png' className='logo-img' alt="logo"></img>
                <IonCardTitle>
                    
                    <h1>Verify Login</h1></IonCardTitle>
                <p>Enter the OTP that will be sent to your mobile number</p>
            </IonCardHeader>
        </>
    )
}

export default OtpHeader;